import React from 'react'

const twenty_six = () => {
    return (
        <div className='container'>
            <h1>Find the sqrt of give n?</h1>
          <div className='containers'>
              We are given an N  we have to find the sqrt of it,<br />Suppose we had given N=4,we have to find to root of it which is 2
          Function sqrt in C returns the square root of a number. To use it, include the "math.h" header file in the program.
          </div>
          <div className='containers'>
         <code className='library'>#include</code>  &lt;stdio.h&gt;<br/>
<code className='library'>#include</code> &lt;math.h&gt;<br/>

<code className='keywords'>int</code> main()<br/>
&#123;<br/>
<code className='keywords'>double</code> num, root;<br/>

<code className='comment'>  /* Input a number from user */</code><br/>
<code className='library'>  printf</code>("Enter any number to find square root: ");<br/>
<code className='library'> scanf</code>("%lf", &num);<br/>

<code className='comment'> /* Calculate square root of num */</code><br/>
 root = <code className='library'>sqrt</code>(num);<br/>

<code className='comment'>/* Print the resultant value */</code><br/>
<code className='library'>printf</code>("Square root of %.2lf = %.2lf", num, root);<br/>

<code className='library'> return </code>0;<br/>
&#125;<br/>
</div>
        </div>
    )
}

export default twenty_six
